import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import ghostImage from '../assets/images/albumimages/ghost.jpg';
import rwcImage from '../assets/images/albumimages/rwc.jpg';
import babyImage from '../assets/images/albumimages/baby.jpg';
import thriveImage from '../assets/images/albumimages/thrive.jpg';
import itchytastyImage from '../assets/images/albumimages/itchytasty.jpg';
import oceanImage from '../assets/images/albumimages/ocean.jpg';
import busyImage from '../assets/images/albumimages/busy.jpg';
import eighteenImage from '../assets/images/albumimages/18.jpg';
import musicJSON from '../data/music.json';

const imageMap = {
    "ghost.png": ghostImage,
    "rwc.png": rwcImage,
    "baby.png": babyImage,
    "thrive.png": thriveImage,
    "itchytasty.png": itchytastyImage,
    "ocean.jpg": oceanImage,
    "busy.jpg": busyImage,
    "18.jpg": eighteenImage
};

const responsive = {
    superLargeDesktop: {
        breakpoint: { max: 4000, min: 3000 },
        items: 5
    },
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 3
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1
    }
};

const MusicCarousel = () => {
    return (
        <Carousel responsive={responsive}
                   autoPlay={true}
                   autoPlaySpeed={3000}
                   infinite={true}>
            {musicJSON.map((album, index) => (
                <a key={index} href={album.website} target="_blank" rel="noopener noreferrer" className="flex flex-col items-center rounded-lg shadow custom-hover-bg dark:border-gray-700 dark:bg-gray-800 dark:hover:bg-gray-700 p-4">
                    <img className="object-cover h-full md:h-64 lg:h-80 rounded-t-lg" src={imageMap[album.images[0].path]} alt={album.images[0].caption} />
                    <div className="mt-4 text-center">
                        <h1 className="text-2xl font-bold tracking-tight">{album.title}</h1>
                        <p className="dark:text-gray-400">{album.release}</p>
                    </div>
                </a>
            ))}
        </Carousel>
    );
};

export default MusicCarousel;